import { Component, OnInit } from '@angular/core';
import { EquipoService } from '../../services/equipo.service';

@Component({
  selector: 'app-jobs',
  templateUrl: './jobs.component.html',
  styleUrls: ['./jobs.component.css']
})
export class JobsComponent implements OnInit {
  isLoaded: boolean = false;
  isPosition: boolean = false;

  jobs: any;
  careers: any;

  constructor(private equipoService: EquipoService) { }

  ngOnInit(): void {
    this.equipoService.getCareersStatic().subscribe({
      next: (careersData) => {
        this.careers = careersData.data;
        if (this.careers.jobs.length > 0) {
          this.isPosition = this.careers.jobs.some(job => job.active);
        }
        this.jobs = this.careers.jobs.filter(job => job.active === true);
        this.isLoaded = true;
      },
      error: (err) => {
        console.log(err)
      }
    })

  }

}
